import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { COLORS, MQS, SIZES, SPACINGS, SHADOWS } from '../app/common/constants/styles';
import Tile from '../app/common/components/Tile';

export const Base = styled.div`
    background-color: ${COLORS.ultralightGrey};
`;

export const BaseWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0 20px;
    max-width: ${SIZES.appMaxWidth}px;
    margin: 0 auto;
    @media (max-width: ${MQS.mq2Max}) {
        padding: ${SPACINGS.base * 2}px;
    }
`;

export const HorizontalWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0 20px;
    max-width: ${SIZES.appMaxWidth}px;
    margin: 0 auto 39px auto;
    @media (max-width: ${MQS.mq2Max}) {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: ${SPACINGS.base * 2}px;
    }
`;

export const Title = styled.h1`
    font-size: 1.5rem;
    line-height: 1.2;
    color: ${COLORS.dark};
    font-weight: 300;
    margin: 0;
    width: 100%;
    @media (max-width: ${MQS.mq2Max}) {
        font-size: 1.375rem;
    }
`;

export const TopWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 ${SPACINGS.base}px;
    margin-top: 40px;
    @media (max-width: ${MQS.mq2Max}) {
        margin-top: 0px;
    }
`;
export const TipOfTitle = styled.div`
    color: ${COLORS.dark2};
    font-size: 0.875rem;
    line-height: 1.5;
    font-weight: 300;
    margin-top: 16px;
`;
export const Greeting = styled.div`
    margin-top: 40px;
    margin-bottom: 13px;
    font-size: 1.125rem;
    color: ${COLORS.dark2};
    @media (max-width: ${MQS.mq2Max}) {
        margin-top: ${SPACINGS.base * 2}px;
    }
`;

export const UserName = styled.span`
    font-weight: 700;
    padding: 0 5px;
`;

export const RouterBaseWrapper = styled.div`
    width: 100%;
    display: flex;
`;

export const Left = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 33.33%;
`;

export const Right = styled.div`
    align-items: top;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 66.66%;
`;

export const PointsTile = styled(Tile)``;

export const pointsTileStyle = css`
    box-shadow: ${SHADOWS.level1};
    margin: ${SPACINGS.base}px;
    flex-grow: 1;
    @media (max-width: ${MQS.mq2Max}) {
        margin: 0;
        margin-bottom: ${SPACINGS.base}px;
    }
`;

export const PointsLink = styled(Link)`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding: 30px;
    text-decoration: none;
    color: #000;
    cursor: pointer;
    border-radius: 4px;
    &:link {
        background: linear-gradient(to bottom right, #97439b, #e8142a);
    }
    &:focus {
        border: 2px solid #590000;
        background: linear-gradient(to bottom right, #97439b, #e8142a);
    }
    &:hover {
        transition: background 0.3s ease-in-out;
        background: linear-gradient(to bottom right, #773f7a, #ac0b1c);
    }
    &:active {
        background: linear-gradient(to bottom right, #97439b, #e8142a);
    }
`;

export const IconWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const TilePointsTitle = styled.h2`
    font-size: 1rem;
    color: ${COLORS.white};
    font-weight: 700;
    margin: 8px 0;
    text-align: left;
`;

export const TilePointsText = styled.p`
    font-size: 0.875rem;
    color: ${COLORS.white};
    margin: 0;
    line-height: 1.5;
    max-width: 100%;
    text-align: left;
`;

export const PointsLine = styled.div`
    border-bottom: 1px solid ${COLORS.lineColor};
    width: 100%;
    margin: 40px 0;
`;

export const AvailablePoints = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${COLORS.white};
    font-size: 0.875rem;
    & span {
        font-size: 3rem;
    }
`;

export const PendingPoints = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${COLORS.white};
    font-size: 0.875rem;
    margin-top: 48px;
    & span {
        font-size: 1.5rem;
    }
`;
export const BaseTile = styled(Tile)``;

export const rightBaseTileStyles = css`
    text-align: center;
    box-shadow: ${SHADOWS.level1};
    margin: ${SPACINGS.base}px;
    flex-grow: 1;
    width: calc(50% - 24px);
    @media (max-width: ${MQS.mq2Max}) {
    }
`;

export const baseTileMobile = css`
    margin: ${SPACINGS.base}px;
    @media (max-width: ${MQS.mq2Max}) {
        margin: ${SPACINGS.base}px 0;
    }
`;
export const ExternalLink = styled.a`
    cursor: pointer;
    text-decoration: none;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.875rem;
    &:hover {
        font-weight: bold;
    }
`;

export const ExternalBlueLink = styled.a`
    color: ${COLORS.linkBlue};
    cursor: pointer;
    transition: font-weight 200ms ease-in;
    text-decoration: none;
    padding-right: 5px;
    &:hover {
        font-weight: bold;
    }
    & + & {
        margin-top: 30px;
    }
`;
export const BackLinkWrapper = styled.div`
    margin: 50px auto 0 8px;
    @media (max-width: ${MQS.mq2Max}) {
        margin-top: 18px;
        margin-left: 0;
    }
`;
export const LogOutWrapper = styled.div`
    margin-left: 8px;
    @media (max-width: ${MQS.mq2Max}) {
        margin-top: 40px;
        margin-left: 0;
    }
`;

export const SignOutButton = styled.button`
    cursor: pointer;
    text-decoration: none;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    border: none;
    background: none;
    &:hover {
        font-weight: bold;
    }
`;

export const ToMembershipWrapper = styled.div`
    margin-left: ${SPACINGS.base}px;
    margin-top: ${SPACINGS.base * 5}px;
    @media (max-width: ${MQS.mq2Max}) {
        margin-top: 18px;
        margin-bottom: 0;
        margin-left: 0;
    }
`;
export const LogOutIcon = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    align-items: center;
    color: ${COLORS.dark1};

    & svg {
        margin-right: 5px;
    }
`;

export const NoPointsWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
`;

export const NoPointsTileBase = styled(Tile)``;

export const noPointsTileStyle = css`
    text-align: center;
    box-shadow: ${SHADOWS.level1};
    margin: ${SPACINGS.base}px;
    width: calc(33.33% - 24px);
    align-items: stretch;
`;

export const NoPointsTileLink = styled(Link)`
    display: flex;
    border-radius: 4px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    min-height: 187px;
    padding: 30px;
    text-decoration: none;
    color: #000;
    cursor: pointer;
    &:focus {
        background-color: ${COLORS.white};
        border: 2px solid ${COLORS.rakutenRed};
    }
    &:hover {
        background-color: ${COLORS.hoverBackground};
        border: 1px solid ${COLORS.grey3};
        transition: background 0.3s ease-in-out;
    }
    &:active {
        background-color: ${COLORS.grey8};
        border: 1px solid ${COLORS.grey3};
    }
`;

export const TileLink = styled(Link)`
    display: flex;
    border-radius: 4px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding: 30px;
    text-decoration: none;
    color: #000;
    cursor: pointer;
    &:focus {
        background-color: ${COLORS.white};
        border: 2px solid ${COLORS.rakutenRed};
    }
    &:hover {
        background-color: ${COLORS.hoverBackground};
        border: 1px solid ${COLORS.grey3};
        transition: background 0.3s ease-in-out;
    }
    &:active {
        background-color: ${COLORS.grey8};
        border: 1px solid ${COLORS.grey3};
    }
`;

export const MyDataWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 33.33%;
`;

export const NoPointsTileWrapper = styled(Tile)``;
export const noPointsTileWrapperStyle = css`
    text-align: center;
    box-shadow: ${SHADOWS.level1};
    margin: ${SPACINGS.base}px;
    width: calc(33.33% - 24px);
    align-items: stretch;
    display: flex;
    align-items: flex-start;
    @media (max-width: ${MQS.mq2Max}) {
        border: 1px solid red;
        width: 100%;
        width: calc(100%-24px);
        margin: 0;
        margin-top: ${SPACINGS.base}px;
    }
`;

export const noPointsMyDataWrapperStyleMobile = css`
    margin: ${SPACINGS.base}px;
    @media (max-width: ${MQS.mq2Max}) {
        margin: 0;
        margin-top: ${SPACINGS.base}px;
    }
`;

export const MyDataLink = styled.a`
    display: flex;
    background-color: ${COLORS.white};
    border-radius: 4px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    min-height: 187px;
    padding: 30px;
    text-decoration: none;
    color: #000;
    cursor: pointer;
    &:focus {
        background-color: ${COLORS.white};
        border: 2px solid ${COLORS.rakutenRed};
        height: 100%;
    }
    &:hover {
        background-color: ${COLORS.hoverBackground};
        border: 1px solid ${COLORS.grey3};
        transition: background 0.3s ease-in-out;
        height: 100%;
    }
    &:active {
        background-color: ${COLORS.grey8};
        border: 1px solid ${COLORS.grey3};
        height: 100%;
    }

    @media (max-width: ${MQS.mq2Max}) {
        min-height: auto;
    }
`;
export const TileTitle = styled.h2`
    font-size: 1rem;
    color: ${COLORS.dark1};
    font-weight: 700;
    margin: 8px 0;
    text-align: left;
`;

export const TileText = styled.p`
    font-size: 0.875rem;
    color: ${COLORS.dark2};
    margin: 0;
    line-height: 1.5;
    max-width: 100%;
    text-align: left;
`;

export const LogoWrapper = styled.span`
    display: inline-block;
    width: 135px;
`;
export const MobileMain = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`;

export const DefaultHeader = styled.header`
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${COLORS.white};
`;

export const BuTile = styled.div`
    background-color: ${COLORS.white};
    border-radius: 4px;
    padding: 0 ${SPACINGS.base * 3}px;
    box-shadow: ${SHADOWS.level1};

    & + & {
        margin-top: 20px;
    }
    @media (max-width: ${MQS.mq2Max}) {
        margin: 0;
        margin-top: ${SPACINGS.base}px;
    }
`;

export const BuTilesWrapper = styled.div`
    display: flex;
    padding: ${SPACINGS.base * 2}px 10px ${SPACINGS.base * 5}px 0px;
    max-width: ${SIZES.appMaxWidth}px;
    margin: 0 auto;
    flex-wrap: wrap;
`;

export const HomeTile = styled(Tile)``;

export const BuHeading = styled.span`
    margin: 20px 8px 20px 8px;
    font-size: 20px;
    font-weight: 600;
    width: 100%;
`;

export const BuContainer = styled.div`
    display: flex;
    width: 100%;
`;

export const BuLeft = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 66.66%;
`;

export const leftBuTileStyles = css`
    text-align: center;
    box-shadow: ${SHADOWS.level1};
    margin: ${SPACINGS.base}px;
    flex-grow: 1;
    width: calc(50% - 24px);
    max-height: 200px;
    position: relative;
`;

export const BuRight = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 33.33%;
`;

export const rightBuTileStyles = css`
    box-shadow: ${SHADOWS.level1};
    margin: ${SPACINGS.base}px;
    width: calc(100% - 24px);
    flex-grow: 1;
`;

export const BuTileLink = styled.a<{ styles?: any }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    text-decoration: none;
    position: relative;
    padding: 25px;
    color: ${COLORS.white};
    border-radius: 4px;
    text-align: center;
    position: relative;
    min-height: 200px;
    ${(props) => (props.styles ? props.styles : '')};
`;

export const BuTileText = styled(TileText)<{ localStyles?: any }>`
    font-size: 18px;
    color: ${COLORS.white};
    margin: 15px 0px;
    ${(props) => (props.localStyles ? props.localStyles : '')};
`;

export const BuLogoImage = styled.img<{ localStyles?: any }>`
    height: 35px;
    ${(props) => (props.localStyles ? props.localStyles : '')};
`;

export const ArrowIcon = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 15px;
    right: 25px;
`;

export const BuSiteLinks = styled.a`
    width: 100%;
    display: flex;
    justify-content: space-between;
    text-decoration: none;
    margin: 10px 0px;
    color: ${COLORS.white};
`;

export const rakutenFranceLogoStyles = css`
    height: 55px;
    position: absolute;
    display: inline-block;
    top: 15px;
`;

export const rakutenFranceStyles = css`
    display: inline-block;
    position: absolute;
    top: 65px;
    padding: 0px 25px;
`;

export const PromotionImageTiles = styled.img`
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    align-item: center;
`;

export const promotionStyle = css`
    ${rightBuTileStyles};
    max-height: 200px;
`;
